
import React from 'react';
import { FileSpreadsheet, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const EmptyState = () => {
  return (
    <div className="text-center py-8 border rounded-md bg-muted/30">
      <FileSpreadsheet className="mx-auto h-8 w-8 text-muted-foreground mb-2" />
      <p className="text-muted-foreground">No pricing data loaded yet.</p>
      <p className="text-sm text-muted-foreground mt-1">Upload an Excel file to view pricing information</p>
      <p className="text-xs text-muted-foreground mt-4">Access to this page is restricted to authorized personnel only.</p>
      
      <div className="mt-6">
        <Link to="/">
          <Button variant="outline" size="sm" className="mx-auto">
            <Home className="mr-2 h-4 w-4" />
            Go To Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default EmptyState;
